mutation JoinYouTubeWaitlist {
  result: StreamToolsJoinYouTubeWaitlist {
    youtubeWaitlistAt
  }
}
